import { encodeSingleFieldToBase64, setTranslatedValues } from '/src/common/general-utils';
import { i18n } from '/plugins/i18n.client';

export const getWhitelistedRecordsPayload = (businessrule, businessruleFilters, whitelistFilters, fields) => ({
  rule: encodeSingleFieldToBase64(
    JSON.stringify({ DataTableName: businessrule.DataTableName, LogicString: businessrule.LogicString })
  ),
  filters: encodeSingleFieldToBase64(JSON.stringify(businessruleFilters)),
  whitelistFilters: encodeSingleFieldToBase64(JSON.stringify(whitelistFilters)),
  BusinessRuleUuid: businessrule.UUID,
  fields: encodeSingleFieldToBase64(JSON.stringify(fields))
});

export const translateAlias = (alias) => {
  if (typeof alias !== 'string') {
    return alias;
  }
  return i18n.global.t(setTranslatedValues(alias));
};

export const resolveColumnHeader = (columnName, widgetHeaderOverride, fieldConfig = [], skipTranslation = false) => {
  if (widgetHeaderOverride && widgetHeaderOverride !== columnName) {
    return skipTranslation ? widgetHeaderOverride : translateAlias(widgetHeaderOverride);
  }

  let configs = fieldConfig;
  if (typeof fieldConfig === 'string') {
    try {
      configs = fieldConfig.sParseJSON ? fieldConfig.sParseJSON([]) : JSON.parse(fieldConfig);
    } catch (e) {
      configs = [];
    }
  }
  if (!Array.isArray(configs)) {
    configs = [];
  }

  const config = configs.find(
    (f) =>
      f.name === columnName ||
      (typeof f.name === 'string' &&
        typeof columnName === 'string' &&
        f.name.toLowerCase() === columnName.toLowerCase())
  );
  if (config?.alias) {
    const duplicateCount = configs.filter((f) => {
      if (!f.alias) return false;
      if (f.alias.trim().toLowerCase() === config.alias.trim().toLowerCase()) return true;
      return translateAlias(f.alias).trim().toLowerCase() === translateAlias(config.alias).trim().toLowerCase();
    }).length;

    const baseAlias = skipTranslation ? config.alias : translateAlias(config.alias);
    return duplicateCount > 1 ? `${baseAlias} (${columnName})` : baseAlias;
  }

  return columnName;
};

export const getColumnsWithAlias = (columns = [], fieldConfig = []) =>
  (columns || []).map((col) => {
    const colName = typeof col === 'string' ? col : col.name;
    const displayName = resolveColumnHeader(colName, null, fieldConfig);
    if (typeof col === 'string') {
      return { name: col, displayName, value: col };
    }
    return { ...col, displayName };
  });
